import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'


import VueAgile from 'vue-agile'

Vue.use(VueAgile)


import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

import LoadScript from 'vue-plugin-load-script';
Vue.use(LoadScript);

import sidebar from './components/sidebar.vue';
Vue.component('sidebar', sidebar);

import navbar  from './components/navbar.vue';
Vue.component('navbar', navbar);

import logo_header   from './components/logo_header.vue';
Vue.component('logo_header', logo_header);

import foother from './components/foother.vue';
Vue.component('foother', foother);


// LIST NAVBAR DINAS




// LIST NAVBAR DINAS




Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
